<template>
  <div class="main bg-primary">
    <div class="headerContainer mb-5">
      <TopDeck
        firstElement="Ajout ingrédients cachés"
        secondElement="CSV"
        :coloredSecond="true"
        actionHeaderIcon="mdi-arrow-left"
        :actionheaderFunction="() => $router.push('/my_ingredients')"
        actionHeaderColor="accent"
        actionHeaderTextColor="white"
      />
    </div>

    <div class="headerWithAction bg-secondary rounded-xl mb-5">
      <v-file-input clearable label="Fichier CSV" variant="outlined" @change="handleFileUpload" accept=".csv"></v-file-input>
    </div>

    <!-- Saisonnalité globale pour l'import -->
    <div class="bg-secondary rounded-xl pa-4 mb-5">
      <SeasonalityPicker
        v-model="seasonMonths"
        :frozen="isFrozen"
        @update:frozen="isFrozen = $event"
      />
      <p class="text-caption text-medium-emphasis mt-2">Ces paramètres seront appliqués à tous les ingrédients importés.</p>
    </div>

    <div v-if="previewData.length > 0" class="preview">
      <div class="rowSpaceBetween">
        <h3>Prévisualisation ({{ previewData.length }} aliments)</h3>

        <v-btn
          color="accent"
          v-if="previewData.length > 0"
          rounded="lg"
          @click="importData"
          class="white-text-button"
        >
          <v-icon class="mr-1">mdi-plus</v-icon>
          <span>Ajouter tout</span>
        </v-btn>
      </div>
      <table class="rounded-xl">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Poids (g)</th>
            <th>Kcal/100g</th>
            <th>Lipides</th>
            <th>Glucides</th>
            <th>Protéines</th>
            <th>Fibres</th>
            <th>Sel</th>
            <th>Sucre</th>
            <th>Valide pour import</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in previewData" :key="i">
            <td>{{ row["ingrédients"] }}</td>
            <td>{{ row["poids (g)"] }}</td>
            <td>{{ row["kcal./100g"] }}</td>
            <td>{{ row["lipides"] }}</td>
            <td>{{ row["glucides"] }}</td>
            <td>{{ row["protéines"] }}</td>
            <td>{{ row["fibres"] }}</td>
            <td>{{ row["Sel"] }}</td>
            <td>{{ row["Sucre"] }}</td>
            <td>
              <span v-if="isRowValid(row)" style="color: green;">✅</span>
              <span v-else style="color: red;">❌</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <v-snackbar v-model="snack.show" :timeout="2500">
    {{ snack.text }}
  </v-snackbar>
  <v-alert v-if="errorMessage" type="error" variant="tonal" class="mt-4">
    {{ errorMessage }}
  </v-alert>
</template>

<script setup>
    import { ref } from "vue";
    import { parseCsvFile } from "@/service/base_ingredient_service";
    import { importRowsToHiddenBaseIngredients } from "@/service/hidden_base_ingredient_service";
    import TopDeck from '@/components/Utils/TopDeck.vue'
    import SeasonalityPicker from '@/components/Kitchen/Ingredients/SeasonalityPicker.vue'

    const previewData = ref([]);
    const errorMessage = ref(null);
    const snack = ref({ show: false, text: "" });
    const seasonMonths = ref([]);
    const isFrozen = ref(false);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        previewData.value = await parseCsvFile(file, "ingrédients");
    };

    const importData = async () => {
        try {
        const validRows = previewData.value.filter((row) => isRowValid(row));
        const res = await importRowsToHiddenBaseIngredients(validRows, { seasonMonths: seasonMonths.value, isFrozen: isFrozen.value });
        alert(`✅ ${res.added} ingrédients ajoutés`);
        } catch (err) {
        console.error("❌ Erreur import:", err);
        alert("Erreur lors de l'import");
        }
    };

    /**
     * Vérifie si une ligne CSV est valide pour import
     */
    function isRowValid(row) {
        const requiredFields = [
        "ingrédients",
        "kcal./100g",
        "lipides",
        "glucides",
        "protéines",
        "fibres",
        // "Sel",
        // "Sucre"
        ];

        return requiredFields.every(
        (   field) => row[field] !== undefined && row[field] !== null && row[field] !== ""
        );
    }
</script>

<style scoped>
    .headerWithAction {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
        padding: 2rem;
    }

    .preview table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 1rem;
    }

    .preview th,
    .preview td {
        border: 1px solid rgb(var(--v-theme-secondary));
        padding: 8px;
        text-align: center;
    }

    .preview th {
        background: rgb(var(--v-theme-tertiary));
    }
</style>
